import { SlicePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgxI18nService } from '@studiohyperdrive/ngx-i18n';
import { StripHtmlPipe } from '@studiohyperdrive/ngx-utils';

import { CypressTagDirective } from '@cjm/cypress/core';
import { VLoketAppRoutePaths } from '@cjm/shared/route-paths';
import { ProductEntity } from '@cjm/shared/types';
import { FaIconComponent, TagComponent } from '@cjm/shared/ui/common';

import { PrimaryButtonComponent } from '../primary-button/primary-button.component';

@Component({
	selector: 'vloket-product-grid-item',
	templateUrl: './product-grid-item.component.html',
	styleUrls: ['./product-grid-item.component.scss'],
	host: {
		'[class.c-product-grid-item-wrapper]': 'true'
	},
	changeDetection: ChangeDetectionStrategy.Default,
	imports: [
		RouterLink,
		FaIconComponent,
		TagComponent,
		StripHtmlPipe,
		SlicePipe,
		PrimaryButtonComponent,
		CypressTagDirective
	]
})
export class ProductGridItemComponent {
	/**
	 * Input property that represents a product entity.
	 * This property is required.
	 */
	@Input({ required: true }) public product: ProductEntity;

	@Input() public hasFavouriteButton: boolean = false;
	@Input() public actionInProgress: string | number = null;

	/**
	 * setItemAsFavoriteClicked will emit an event when the "set as Favorite" button on an individual item is clicked.
	 */
	@Output() public setItemAsFavoriteClicked: EventEmitter<string | number> = new EventEmitter<string | number>();
	/**
	 * removeItemAsFavoriteClicked will emit an event when the "remove as Favorite" button on an individual item is clicked.
	 */
	@Output() public removeItemAsFavoriteClicked: EventEmitter<string | number> = new EventEmitter<string | number>();

	public readonly offersRoutePaths: typeof VLoketAppRoutePaths = VLoketAppRoutePaths;

	constructor(protected i18nService: NgxI18nService) {}
}
